// src/pages/Login.tsx
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api/axios";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log("🔍 [App] handleSubmit fired", { username, password });
    setError(null);

    try {
      console.log("🔍 [App] calling API:", api.defaults.baseURL + "/token/");
      // <-- remove leading slash here
      const response = await api.post<{ access: string; refresh: string }>(
        "token/",
        { username, password }
      );
      console.log("✅ [App] login succeeded", response.data);

      localStorage.setItem("authToken", response.data.access);
      navigate("/dashboard");
    } catch (err: any) {
      console.error("❌ [App] login error", err.response?.data || err);
      const errorData = err.response?.data || { message: "Unknown error" };
      setError(JSON.stringify(errorData, null, 2));
    }
  };

  return (
    <div className="bg-[#fdf6ee] font-sans px-4 py-10 min-h-screen flex justify-center">
      <div className="w-full max-w-md mt-12 space-y-6">
        <h2 className="text-3xl font-bold text-center">Welcome Back</h2>
        <p className="text-center text-sm text-gray-500">
          Log in with your email and password
        </p>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 text-sm px-4 py-2 rounded text-left whitespace-pre-wrap">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Email"
            className="w-full px-4 py-3 rounded-full border border-gray-300"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="w-full px-4 py-3 rounded-full border border-gray-300"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className="w-full bg-black text-white rounded-full px-6 py-3 hover:bg-gray-900 transition"
          >
            Log In
          </button>
        </form>

        <div className="flex justify-between text-sm mt-2">
          <Link to="/reset-password" className="underline text-black">
            Forgot password?
          </Link>
          <Link to="/signup" className="underline text-black">
            Don’t have an account?
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;
